/** P01 and MO01: the front door. */
export const home = {
  eyebrow: 'A little play goes a long way',
  eyebrowPhone: 'A little play',
  title: 'A little play.\nA lot of fun.',
  subtitle:
    'Draw, guess, spot, bluff and remember. On your own, or with good company.',
  subtitlePhone: 'Good games for good company.',
};
